import React from 'react';

const CitadelSection = () => {
  return (
    <section className="py-12 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl max-w-2xl mx-auto bg-gray-100">
          <div className="relative w-full" style={{ height: '500px' }}>
            <img
              src="/citadel.jpg"
              alt="Erbil Citadel"
              className="w-full h-full object-contain"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a1d2e]/60 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="max-w-4xl">
                <h3 className="text-white text-2xl md:text-3xl font-bold mb-2">
                  Erbil Citadel - UNESCO World Heritage Site
                </h3>
                <p className="text-gray-200 text-lg">
                  قلعة أربيل - موقع التراث العالمي لليونسكو | قەڵای هەولێر - مێژووی کۆنی کوردستان
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CitadelSection;
